import { general, useEditorRuntimeStore } from '@modules/editor';

import { type InspirationImageElement } from '$/pages/InspirationEditorPage/plugins/inspiration';
import { useInspirationEditorStore } from '$/pages/InspirationEditorPage/stores/useInspirationEditorStore';

export const getObjectAtPosition = async (
  objects: string[],
  cursorX: number,
  cursorY: number,
) => {
  const imageElement =
    general.actions.getElement<InspirationImageElement>('preview');

  if (!imageElement) return undefined;

  const viewportCoords = general.actions.sceneCoordsToViewportCoords({
    x: imageElement.x,
    y: imageElement.y,
  });

  const localCursorCoords = {
    x: cursorX - viewportCoords.x,
    y: cursorY - viewportCoords.y,
  };

  const zoom = useEditorRuntimeStore.getState().zoom.value;
  const scaleX = imageElement.originalWidth / (imageElement.width * zoom);
  const scaleY = imageElement.originalHeight / (imageElement.height * zoom);

  const imageCoords = {
    x: Math.round(localCursorCoords.x * scaleX),
    y: Math.round(localCursorCoords.y * scaleY),
  };

  const isOutOfBounds =
    imageCoords.x < 0 ||
    imageCoords.x > imageElement.originalWidth ||
    imageCoords.y < 0 ||
    imageCoords.y > imageElement.originalHeight;

  if (isOutOfBounds) return undefined;

  const areCoordsInMask = useInspirationEditorStore.getState().areCoordsInMask;
  for (const mask of objects) {
    if (await areCoordsInMask(mask, imageCoords.x, imageCoords.y)) {
      return mask;
    }
  }

  return undefined;
};
